/* eslint-disable react/jsx-pascal-case */
import React, { useState, useEffect, useContext, useRef } from "react";
import { Outlet, useLocation, Link, useNavigate } from 'react-router-dom'
import { Row, Col, Typography, Button, Space, Modal, Form, Input, TimePicker, Select, QRCode, Upload, message, Card, ConfigProvider, DatePicker, Popconfirm, Switch, Tag } from "antd";
import { LoadingOutlined, PlusOutlined, EnvironmentFilled } from '@ant-design/icons';
import MainHeader from '../utility/Main_header'
import axios from "axios";
import { Pie } from '@ant-design/plots';
import DepartmentRole from "../organization_structure/components/DepartmentRole";
import { url, client_id } from '../../components/login/setting'
import ProTable_ot from "../utility/ProTable_ot";
import dayjs from 'dayjs'
import AdminModal from "../utility/AdminModal";
import AdminTeacher from "../cram_school/AdminTeacher";
const LocationData = ({
    modalStyle = {
        backgroundColor: "#f5fcf9",
        borderTopColor: "#7991d4"
    },
    openButtonStyle = {
        backgroundColor: "#fff8c8",
        color: "#000"
    },
    openButtontext = "新增題目",
    title = "新增地點",
    ...props
}) => {
    const navigate = useNavigate();

    const language = useContext(ConfigProvider.ConfigContext).locale.locale

    const actionRef = useRef()
    const [modal, setModal] = useState()
    const [patrolType, setPatrolType] = useState([])
    const [check, setCheck] = useState([])
    const [departmentData, setDepartmentData] = useState([]);
    const [roleData, setRoleData] = useState([]);
    const [form] = Form.useForm()
    const [edit, setEdit] = useState(false)
    const columns = [
        // {
        //     title: '照片',
        //     dataIndex: 'avatar',
        //     key: 'avatar',
        //     width: '80px',
        //     render: () => {
        //         return (
        //             <Avatar />
        //         )
        //     }
        // },
        {
            title: '接送地點',
            dataIndex: 'patrol_location_name',
            key: 'patrol_location_name',
            width: "10rem",
            render: (e) => {
                return (<>{e}
                    <div
                        style={{
                            borderRadius: '8px',
                            backgroundColor: '#f0f0f0',
                            fontSize: '1rem',
                            padding: '2px 6px',
                            textAlign: 'center',
                            cursor: 'pointer',
                            width: 'fit-content'
                        }} >
                        <EnvironmentFilled
                            style={{
                                fontSize: '1rem',
                                color: "red"
                            }}
                        />
                        查看地點
                    </div>
                </>)
            }
        },
        {
            title: '接送地址',
            dataIndex: 'patrol_location_address',
            key: 'patrol_location_address',
            width: "10rem",
            render: (text, record, index) => (<>
                {text}
            </>)
        },
        {
            title: '訊息自動發送',
            dataIndex: 'patrol_location_activity',
            key: 'patrol_location_activity',
            render: (text, record, index) => {
                if (text) {
                    return <Tag color="green">
                        開啟中
                    </Tag>
                }
                else {
                    return (
                        <Tag color="blue">
                            關閉中
                        </Tag>
                    )
                }
            }



        },
        {
            title: '預約發送時間',
            dataIndex: 'patrol_start_time',
            key: 'patrol_start_time',
            render: (text, record) => (<>
                {record.patrol_start_time && dayjs(text, 'HH:mm').format('A hh:mm')}
            </>)
        },
        // {
        //     title: '數位QRCode',
        //     sorter: false,
        //     render: (text, record, index) => {
        //         const punch_type_id = 1
        //         const value = (record?.patrol_location_punch_data || []).find(find_item => find_item.punch_type_id === 1)?.patrol_location_punch_value
        //         const state = JSON.stringify({
        //             service: `/cramSchool/punchInAndOut/PunchOut/${value}`,
        //             state: value
        //         })
        //         return (<Space direction="vertical">
        //             {/* {text} */}
        //             {value && <QRCode
        //                 value={
        //                     'https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=' +
        //                     client_id + '&redirect_uri=' + url + '&state=' + state +
        //                     '&scope=profile%20openid&nonce=' + value
        //                 }
        //             // status="expired"
        //             // onRefresh={() => console.log('refresh')}
        //             />}
        //             <Button onClick={() => onRefresh({ ...record, punch_type_id })}>重新生成</Button>
        //         </Space>)
        //     },
        // },
        {
            title: '操作',
            sorter: false,
            render: (text, record) => {
                return (
                    <Space direction="vertical">
                        <Space>
                            <Button
                                type="text"
                                style={{
                                    color: "#6495fa"
                                }}
                                onClick={() => {
                                    console.log({ record })
                                    form.resetFields()
                                    form.setFieldsValue({
                                        ...record,

                                        patrol_start_time: dayjs(record?.patrol_start_time, 'HH:mm'),
                                        patrol_end_time: dayjs(record?.patrol_end_time, 'HH:mm')
                                    })
                                    setEdit(true)
                                    setModal(true)
                                }}>編輯</Button>
                            <Popconfirm
                                title="刪除人員"
                                description="確定要刪除此人員嗎？"
                                onConfirm={() => onDelete([{
                                    patrol_location_id: record?.patrol_location_id
                                }])}
                                onCancel={() => { }}
                            >
                                <Button type={'text'} style={{ color: 'red' }}>刪除</Button>
                            </Popconfirm>
                        </Space>
                        <Button
                            style={{
                                color: "#407586"
                            }}
                            type="text"
                            onClick={() => {
                                goToQRcodePunch(record?.patrol_location_id)
                            }}>
                            前往打卡簽到
                        </Button>
                        <Button type="text" style={{ color: 'green' }}
                            onClick={() => {
                                axios
                                    .post('/cramSchool/api/punch_in')
                                    .then(response => {
                                        message.success('發送成功')
                                    })
                                    .catch(() => {
                                        message.error('發送失敗')
                                    })
                            }}
                        >發送預約訊息</Button>


                    </Space>
                )
            }
        },
        {
            title: '教室打卡',
            sorter: false,
            // render: (text, record) => {
            //     return (
            //         <Space direction="vertical">
            //             {
            //                 record.grade_class_data.map((value) => {
            //                     return (
            //                         <Button
            //                             style={{
            //                                 color: "#407586"
            //                             }}
            //                             type="text"
            //                             onClick={() => {
            //                                 goToClassQRcodePunch(record?.patrol_location_id, value?.grade_class_id)
            //                             }}>
            //                             {value?.grade_name}{value?.lesson_category_name} 打卡簽到
            //                         </Button>
            //                     )

            //                 })
            //             }

            //         </Space>
            //     )
            // }
        },
    ];

    const [dataSource, setDataSource] = useState([
        {
            key: '1',
            avatar: 'A761',
            location: '高雄市三民區自由二路路口',
            unit: '單位A',
            type: '特殊性接送',
            startTime: '2023/4/5',
            endTime: '2024/4/5',
            qrcode: '',
            nfccode: '456787654',
            oprate: '',
        },
        {
            key: '2',
            avatar: 'A345',
            location: '高雄市苓雅區中正一路路口',
            unit: '單位B',
            type: '例行性接送',
            startTime: '2023/4/5',
            endTime: '2024/4/5',
            qrcode: '',
            nfccode: '45768908',
            oprate: '',
        },
    ]);
    const [selected_info, setSelectedInfo] = useState([])
    const [selected, setSelected] = useState([])
    const getType = () => {
        axios
            .get('/hrms/api/patrol_type')
            .then(response => {
                setPatrolType(response.data.data)
            })
    }
    const onRefresh = (record) => {
        axios
            .post('/hrms/api/patrol_location_punch', [
                {
                    ...record,
                    patrol_location_punch_value: Date.now(),
                }
            ])
            .then(response => {
                actionRef.current.reload()
            })

        // let random_index = Math.floor(Math.random() * 3)
        // let temp = ["https://orange-technic.com/index.php/en/", "https://www.youtube.com/", "https://www.google.com/?&bih=815&biw=1440&rlz=1C5CHFA_enTW1017TW1017&hl=zh-TW"]

        // setDataSource(pre => {
        //     return pre.map((value, index) => {
        //         if (index === renderIndex) {
        //             return {
        //                 ...value,
        //                 qrcode: temp[random_index]
        //             }
        //         }
        //         else {
        //             return {
        //                 ...value
        //             }
        //         }
        //     })
        // })
    }

    const getDepartmentData = () => {
        axios
            .get('/organization_structure/api/department', {
            })
            .then((response) => {
                setDepartmentData(response?.data?.data)
            })
    }

    const changeDepartmentRole = (departmentRoleDataTemp) => {
        let departmentRoleDataResult = []
        // setDepartmentRoleData(
        departmentRoleDataResult = departmentRoleDataTemp.map((item, index) => {
            let departmentId = 0
            let roleId = 0
            departmentData.map((departmentDataItem, i) => {
                if (departmentDataItem.classify_structure_type_id === item.department_classify_structure_type_id) {
                    departmentId = departmentDataItem.department_id
                    roleData.map((roleDataItem, ii) => {
                        if (roleDataItem.classify_structure_type_id === item.role_classify_structure_type_id) {
                            roleId = roleDataItem.role_id
                        }
                    })
                }
            })
            return (
                {
                    department_id: departmentId,
                    role_id: roleId
                }
            )
        })
        return departmentRoleDataResult;
    }

    const onFinish = (values) => {
        let patrol_start_time = dayjs(values.patrol_start_time).add(8, 'hour')

        if (values.patrol_location_id) {
            axios
                .patch('/hrms/api/patrol_location', [
                    {
                        ...values,
                        patrol_location_activity: values?.patrol_location_activity ? 1 : 0,
                        patrol_start_time: patrol_start_time
                    }
                ])
                .then(() => {
                    message.success('修改成功')
                    actionRef.current.reload()
                    setModal(false);
                })
                .catch(() => {
                    message.error('修改失敗，請檢查資訊是否正確填寫')
                })
        } else {
            axios
                .post('/hrms/api/patrol_location', [
                    {
                        ...values,
                        patrol_location_activity: values?.patrol_location_activity ? 1 : 0,
                        patrol_start_time: patrol_start_time

                    }
                ])
                .then(() => {
                    message.success('新增成功')
                    actionRef.current.reload()
                    setModal(false);
                })
                .catch(() => {
                    message.error('新增失敗，請檢查資訊是否正確填寫')
                })
        }
    }
    const goToQRcodePunch = (patrol_location_id) => {
        navigate(`/cramSchool/punchInAndOut/QRcodePunch/${patrol_location_id}`);
    }
    const goToClassQRcodePunch = (patrol_location_id, grade_class_id) => {
        navigate(`/cramSchool/punchInAndOut/QRcodePunch/${patrol_location_id}/${grade_class_id}`);
    }
    const rowSelection = {
        onSelectAll: (selected, selectedRows, changeRows) => {
            if (selected) {
                setSelected((pre => {
                    return [
                        ...pre,
                        ...changeRows.map((value, key) => {
                            return value.key
                        })
                    ]
                }))
                setSelectedInfo((pre) => {
                    return [
                        ...pre,
                        ...changeRows
                    ]
                })
            }
            else {
                setSelected((pre => {
                    return pre.filter(row => changeRows.includes(row))
                }))
                setSelectedInfo((pre) => {
                    return pre.filter(row => changeRows.key === row.key)
                })
            }
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            if (selected) {
                setSelected((pre => {
                    return [...pre, record.key]
                }))
                setSelectedInfo((pre => {
                    return [...pre, record]
                }))
            }
            else {
                setSelected((pre => {
                    return pre.filter(row => row !== record.key)
                }))
                setSelectedInfo((pre => {
                    return pre.filter(row => row.key !== record.key)
                }))
            }
        },

    };
    const onDelete = (data) => {
        axios
            .delete('/hrms/api/patrol_location', {
                data
            })
            .then(response => {
                if (response.data?.status === "success") {
                    message.success("刪除成功")
                }
                else {
                    message.error("刪除失敗")
                }
            })
            .finally(() => {
                // onFinally()
                onCleanSelected()
                actionRef.current.reload()

            })

    }
    const onCleanSelected = () => {
        setSelected([])
        setSelectedInfo([])
    }
    useEffect(() => {
        getType()
        getDepartmentData()
    }, [])

    return (
        <>
            <AdminModal
                {...props}
                edit={edit}
                editcard={{}}
                title={(<>
                    <Col
                        style={{
                            fontWeight: 'bold',
                            fontSize: '20px',
                            position: 'absolute',
                            zIndex: 99,
                            top: 53,
                            left: 32
                        }} >
                        {edit ? "修改" : "新增"}地點
                    </Col>
                </>)}
                modalStyle={
                    {
                        ...modalStyle,
                        borderTopColor: !edit ? '#e84f75' : '#f09a45'

                    }
                }
                uploads={false}
                open={modal}
                cancel={() => setModal(false)}
                onOk={() => {
                    form.submit()
                }}
                handleEdit={() => { form.submit() }}
                handleSubmit={() => { form.submit() }}
            >
                <Row>
                    <Col>
                        接送地點
                    </Col>
                    <Col span={24}>
                        <Form
                            name="basic"
                            form={form}
                            labelCol={{
                                span: 8,
                            }}
                            wrapperCol={{
                                span: 16,
                            }}
                            style={{
                                maxWidth: 600,
                            }}
                            initialValues={{
                                remember: true,
                            }}
                            onFinish={onFinish}
                            autoComplete="off"
                        >
                            <Form.Item
                                name="patrol_location_id"
                                noStyle
                            >
                                <Input hidden />
                            </Form.Item>
                            <Form.Item
                                label="接送地點"
                                name="patrol_location_name"
                                rules={[
                                    {
                                        required: true,
                                    },
                                ]}
                            >
                                <Input placeholder="請輸入地點" style={{ width: '90%' }} />
                            </Form.Item>
                            <Form.Item
                                label="接送地址"
                                name="patrol_location_address"
                                rules={[
                                    {
                                        required: true,
                                    },
                                ]}
                            >
                                <Input placeholder="請輸入地點" style={{ width: '90%' }} />
                            </Form.Item>
                            <Form.Item
                                name={'department_id'}
                                initialValue={206}
                                noStyle
                            >
                                <Input hidden />
                            </Form.Item>
                            <Form.Item
                                label="每日發送時間"
                                name="patrol_start_time"
                                rules={[
                                    {
                                        required: true,
                                    },
                                ]}
                            >
                                <TimePicker
                                    format={'hh:mm A'}
                                    minuteStep={15}
                                    changeOnBlur
                                />
                            </Form.Item>
                            <Form.Item
                                label="訊息自動發送"
                                name="patrol_location_activity"
                                valuePropName="checked"
                                rules={[
                                    {
                                        required: true,
                                    },
                                ]}
                                initialValue={true}
                            >
                                <Switch checkedChildren="開啟" unCheckedChildren="關閉" />
                            </Form.Item>

                        </Form>
                    </Col>
                </Row>
            </AdminModal>
            <Row>
                <Col
                    span={24}>
                    <ProTable_ot
                        actionRef={actionRef}
                        request={async (params = {}, sort, filter) => {
                            return axios.get('/hrms/api/patrol_location',
                                {
                                    params: {
                                        ...params,
                                        custom_filter_key: check,
                                        custom_filter_value: params?.keyword,
                                        order: sort && Object.entries(sort).map(([map_key, map_value]) => (
                                            JSON.stringify({
                                                column: map_key,
                                                type: map_value
                                            })
                                        )),
                                    },
                                }
                            )
                                .then(response => {
                                    let data = response.data.data.map((value) => {
                                        return {
                                            ...value,
                                            patrol_location_activity: value?.patrol_location_activity === 1 ? true : false
                                        }
                                    })
                                    return {
                                        ...response.data,
                                        data: data
                                    }
                                })
                        }}
                        columns={columns}
                        toolBarRender={() => [
                            <Button
                                style={{
                                    backgroundColor: "#fff8c8",
                                    color: "#000"
                                }}
                                onClick={() => {
                                    setEdit(false)
                                    form.resetFields()
                                    setModal(true)
                                }}
                            >
                                新增地點
                            </Button>,
                            <Button
                                onClick={() => {
                                    onDelete(selected_info)
                                }}
                                style={{
                                    backgroundColor: 'rgba(255, 242, 237, 1)'
                                }}
                            >
                                批次刪除
                            </Button>,
                            // <Button
                            //     className='example'
                            //     style={{
                            //         background: 'rgba(43, 193, 123, 1)',
                            //         color: '#ffffff'
                            //     }}
                            // >
                            //     匯出資料
                            // </Button>,
                            // <Button
                            //     className='example'
                            //     style={{
                            //         backgroundColor: '#41A084',
                            //         color: '#FFFFFF'
                            //     }}
                            // >
                            //     匯入資料
                            // </Button>
                        ]}
                        rowKey={"key"}
                        rowSelection={{
                            type: 'checkbox',
                            selectedRowKeys: selected,
                            ...rowSelection,
                        }}
                        tableAlertRender={({ selectedRowKeys, selectedRows }) => {
                            return (
                                <Space size={24}>
                                    <span>
                                        已選 {selectedRowKeys.length} 項
                                        <Typography.Link style={{ marginInlineStart: 8 }} onClick={onCleanSelected}>
                                            取消選擇
                                        </Typography.Link>
                                    </span>
                                </Space>
                            );
                        }}
                        tableAlertOptionRender={() => {
                            return (
                                <Space size={16}>
                                    {/* <Typography.Link>匯出資料</Typography.Link> */}
                                </Space>
                            )
                        }}
                        check={check}
                        setCheck={setCheck}
                        scroll={{
                            x: "max-content"
                        }}
                    />
                </Col>

            </Row >
        </>
    )
}

const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
};
const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
        message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        message.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
};


const UploadButton = () => {
    const [loading, setLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState();
    const handleChange = (info) => {
        if (info.file.status === 'uploading') {
            setLoading(true);
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            getBase64(info.file.originFileObj, (url) => {
                setLoading(false);
                setImageUrl(url);
            });
        }
    };
    const uploadButton = (
        <div>
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Upload
            </div>
        </div>
    );
    return (
        <>
            <Upload
                name="avatar"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                beforeUpload={beforeUpload}
                onChange={handleChange}
            >
                {imageUrl ? (
                    <img
                        src={imageUrl}
                        alt="avatar"
                        style={{
                            width: '100%',
                        }}
                    />
                ) : (
                    uploadButton
                )}
            </Upload>
        </>
    );
};
const TypePie = () => {
    const [data, setData] = useState([])

    const config = {
        appendPadding: 10,
        data,
        angleField: 'value',
        colorField: 'type',
        radius: 1,
        innerRadius: 0.6,
        height: 150,
        label: {
            type: 'inner',
            offset: '-50%',
            content: '{value}',
            style: {
                textAlign: 'center',
                fontSize: 14,

            },
        },
        interactions: [
            {
                type: 'element-selected',
            },
            {
                type: 'element-active',
            },
        ],
        statistic: {
            title: false,
            content: {
                style: {
                    whiteSpace: 'pre-wrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                },
            },
        },
    };
    const getPunchRecordStatistcs = () => {
        let params = {
            punch_record_time_start: "2023-12-12",
            punch_record_time_end: "2023-09-30"
        }
        axios
            .get('/cramSchool/api/punch_record/statistcs', {

            })
            .then(response => {
                let data = response.data?.data
                setData(data)
                console.log(data)
            })
            .catch(() => {

            })

    }
    useEffect(() => {
        getPunchRecordStatistcs()
    }, [])
    return (
        <Row >
            <Col span={24}>
                <Row  >
                    <Col >
                        <Typography.Title level={5}>
                            今日接送類型統計圖
                        </Typography.Title >
                    </Col>
                </Row>
            </Col>
            <Col span={24}>
                <Pie {...config} />
            </Col>
        </Row>
    );
};
export default LocationData